import { notifyListRefresh } from "../context/tabContext";
import { resolveEntityPath } from "./resolveEntityPath";
import {
  normalizePathname,
  refreshOpenDetailTab,
} from "./tabNavigation";

const TERMINAL_MCA_STATUSES = [
  "APPROVED",
  "REJECTED",
  "CANCELLED",
  "TERMINATED",
];

export const isTerminalMcaStatus = (status) =>
  TERMINAL_MCA_STATUSES.includes(status);

const resolveQuizBasePath = (userRole, currentPathname) =>
  resolveEntityPath("quiz", userRole, currentPathname) ??
  (currentPathname?.startsWith("/management")
    ? "/management/quiz"
    : "/operation/quiz");

const refreshTabByKey = (tabActions, tabKey) => {
  if (!tabActions?.enabled || !tabKey) return false;
  const tab = tabActions.getTabs()?.find((entry) => entry.key === tabKey);
  if (!tab) return false;
  tabActions.refreshTab(tab.id);
  return true;
};

export function refreshEntityTabForMcaRequest(
  tabActions,
  { targetEntity, targetEntityId, status, userRole, currentPathname }
) {
  if (!targetEntity || !targetEntityId) return false;
  if (status && !isTerminalMcaStatus(status)) return false;
  if (!tabActions?.enabled) return false;

  const id = String(targetEntityId);

  if (targetEntity === "quiz") {
    const basePath = resolveQuizBasePath(userRole, currentPathname);
    const editKey = normalizePathname(`${basePath}/${id}/edit`);
    const viewKey = normalizePathname(`${basePath}/${id}`);
    const refreshed =
      refreshTabByKey(tabActions, editKey) ||
      refreshTabByKey(tabActions, viewKey);
    notifyListRefresh(normalizePathname(basePath));
    return refreshed;
  }

  const pathname = resolveEntityPath(targetEntity, userRole, currentPathname);
  if (!pathname) return false;

  const refreshed = refreshOpenDetailTab(tabActions, pathname, id);
  notifyListRefresh(normalizePathname(pathname));
  return refreshed;
}
